export default __webpack_public_path__ + "static/media/starIcon.bc20c10f.svg";